module.exports = __webpack_public_path__ + "static/media/White_Boxes.07d3d02f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/White_Boxes.png
// module id = 1580
// module chunks = 0